import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import { Button } from '../ui/button';
import { Lock, Check } from 'lucide-react';

/**
 * Upsell card shown to free-plan users when they navigate to /signatures.
 * Pitches the digital-signature feature and routes to /billing for upgrade.
 *
 * Extracted from pages/SignaturesHub.jsx.
 */
export function UpsellCard() {
  return (
    <Card className="max-w-xl mx-auto mt-12 border-emerald-200 bg-emerald-50/30 dark:bg-emerald-950/20"
          data-testid="esign-upsell-card">
      <CardHeader>
        <div className="flex items-center gap-2">
          <Lock className="w-5 h-5 text-emerald-600" />
          <CardTitle>Digital Signatures · Paid Plan</CardTitle>
        </div>
        <CardDescription>
          Send PDFs to clients for legally-binding electronic signatures, with the signed
          copy auto-filed in your Documents Hub. Available on Starter and above ($19.99/mo).
        </CardDescription>
      </CardHeader>
      <CardContent>
        <ul className="text-sm space-y-1.5 text-foreground/80 mb-4">
          <li className="flex gap-2"><Check className="w-4 h-4 text-emerald-600 mt-0.5"/> Drag-place signature, date, and text fields on any PDF</li>
          <li className="flex gap-2"><Check className="w-4 h-4 text-emerald-600 mt-0.5"/> Reusable templates for engagement letters &amp; contracts</li>
          <li className="flex gap-2"><Check className="w-4 h-4 text-emerald-600 mt-0.5"/> Email + tokenized signer link (no signer account required)</li>
          <li className="flex gap-2"><Check className="w-4 h-4 text-emerald-600 mt-0.5"/> E-SIGN / UETA compliant audit trail + SHA-256 hash</li>
          <li className="flex gap-2"><Check className="w-4 h-4 text-emerald-600 mt-0.5"/> Signed PDF + Certificate of Completion auto-filed in the chosen folder</li>
        </ul>
        <Button asChild className="w-full" data-testid="esign-upgrade-btn">
          <a href="/billing">Upgrade to unlock</a>
        </Button>
      </CardContent>
    </Card>
  );
}

export default UpsellCard;
